import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter as Router } from 'react-router-dom'; // HashRouter
import AppWrapper from './AppWrapper';
//import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './hooks/auth-provider';
import { PrimeReactProvider } from 'primereact/api';
import { addLocale } from 'primereact/api';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Configure Serbian locale for PrimeReact with DD-MM-YYYY date format
addLocale('sr', {
    firstDayOfWeek: 1,
    dayNames: ['Nedelja', 'Ponedeljak', 'Utorak', 'Sreda', 'Četvrtak', 'Petak', 'Subota'],
    dayNamesShort: ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'],
    dayNamesMin: ['Ne', 'Po', 'Ut', 'Sr', 'Če', 'Pe', 'Su'],
    monthNames: ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
    today: 'Danas',
    clear: 'Obriši',
    dateFormat: 'dd-mm-yy',
    weekHeader: 'Ned'
});

//const publicUrl = process.env.PUBLIC_URL;

const root = ReactDOM.createRoot(document.getElementById('root'));
const value = {
    ripple: true,
    locale: 'sr'
};

root.render(
    // <React.StrictMode>
    <Router>
        <PrimeReactProvider value={value}>
            <AuthProvider>
                <AppWrapper></AppWrapper>
            </AuthProvider>
        </PrimeReactProvider>
    </Router>
    // </React.StrictMode>
);

// Register service worker for PWA functionality
// This enables offline support and automatic version checking
serviceWorkerRegistration.register({
    onUpdate: (registration) => {
        // console.log('Nova verzija aplikacije je dostupna!');
    },
    onSuccess: (registration) => {
        // console.log('Service Worker uspešno registrovan.');
    }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

